<div id="conversion_details_panel">
    <div class="table-responsive">
        <table class="table table-hover table-sm">
            <tbody>
                <tr>
                    <td class="propertyName vcenter">Target Instance</td>
                    <td class="propertyValue vcenter">
                        <mat-radio-group [value]="fields.spectrumInstanceType" aria-label="Select an option" class="radio-group">
                            <mat-radio-button value="On Prem" name="onPremRadio" class="radio-button" ngDefaultControl
                            [(ngModel)]="fields.spectrumInstanceType">On Prem</mat-radio-button>&nbsp;&nbsp;
                            <mat-radio-button value="Cloud" name="cloudRadio" class="radio-button" ngDefaultControl
                            [(ngModel)]="fields.spectrumInstanceType">Cloud</mat-radio-button>
                        </mat-radio-group>
                    </td>
                </tr>
            </tbody>
            <tbody [ngClass]="{'hidden': fields.spectrumInstanceType === 'Cloud'}">
                <tr class="firstRow">
                    <td class="propertyName" [ngClass]="{'errorHighlight': isTouched(subProjectId) && fields.invalidSubProjectId}">Sub Project ID</td>
                    <td class="propertyValue">
                        <input #subProjectId class="propertyText" [(ngModel)]="fields.subProjectId" (input)="filterSubProjectId($event)"
                        maxlength="50" (blur)="detectChanges(true)"/>
                        <div class="errorMessage" [ngClass]="{'hidden': (!(isTouched(subProjectId)) || !fields.invalidSubProjectId)}">
                            'Sub Project ID' is required
                        </div>
                        <div class="hint">A Project ID used to identify the project associated with the file</div>
                    </td>
                </tr>
            </tbody>
            <tbody [ngClass]="{'hidden': fields.spectrumInstanceType === 'On Prem'}">
                <tr class="sectionHeader">
                    <td colspan="2">Loftware Cloud Enterprise SP Details</td>
                </tr>
                <tr>
                    <td class="propertyName" [ngClass]="{'errorHighlight': isTouched(spectrumUrl) && fields.invalidUrl}">URL</td>
                    <td class="propertyValue">
                        <input #spectrumUrl class="propertyText" [(ngModel)]="fields.spectrumServer" (blur)="detectChanges(true)" />
                        <div class="errorMessage" [ngClass]="{'hidden': (!(isTouched(spectrumUrl)) || !fields.invalidUrl)}">
                            'URL' is required
                        </div>
                        <div class="hint">The URL of the target Loftware Cloud Enterprise SP instance</div>
                    </td>
                </tr>
                <tr>
                    <td class="propertyName" [ngClass]="{'errorHighlight': isTouched(spectrumUserName) && fields.invalidUserName}">User Name</td>
                    <td class="propertyValue">
                        <input #spectrumUserName class="propertyText" [(ngModel)]="fields.spectrumUser" (blur)="detectChanges(true)"/>
                        <div class="errorMessage" [ngClass]="{'hidden': (!(isTouched(spectrumUserName)) || !fields.invalidUserName)}">
                            'User Name' is required
                        </div>
                        <div class="hint">A user name associated with the Loftware Cloud Enterprise SP server account</div>
                    </td>
                </tr>
                <tr>
                    <td class="propertyName" [ngClass]="{'errorHighlight': isTouched(spectrumPassword) && fields.invalidPassword}">Password</td>
                    <td class="propertyValue">
                        <input #spectrumPassword type="password" class="propertyText" [(ngModel)]="fields.spectrumPass" (blur)="detectChanges(true)" />
                        <div class="errorMessage" [ngClass]="{'hidden': (!(isTouched(spectrumPassword)) || !fields.invalidPassword)}">
                            'Password' is required
                        </div>
                        <div class="hint">The password associated with the Loftware Cloud Enterprise SP server account</div>
                    </td>
                </tr>
                <tr class="sectionHeader">
                    <td colspan="2">Target Folder</td>
                </tr>
                <tr>
                    <td class="propertyName" [ngClass]="{'errorHighlight': isTouched(spectrumFolderName) && fields.invalidTargetFolder}">Folder Name</td>
                    <td class="propertyValue">
                        <input #spectrumFolderName class="propertyText" [(ngModel)]="fields.subProjectId" (blur)="detectChanges(true)" />
                        <div class="errorMessage" [ngClass]="{'hidden': (!(isTouched(spectrumFolderName)) || !fields.invalidTargetFolder)}">
                            'Folder Name' is required and must represent a valid Loftware Cloud Enterprise SP folder name
                        </div>
                        <div class="hint">The name of the target folder in Loftware Cloud Enterprise SP</div>
                    </td>
                </tr>
                <tr>
                    <td class="propertyName">Version Control</td>
                    <td class="propertyValue"><input type="checkbox" [(ngModel)]="fields.createVersions" />
                        <div class="hint">If set, version control will be enabled on folder creation</div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>